import { Link } from "react-router-dom";
import { X } from "lucide-react";
import "./armeria.css";

/**
 * Modal shown when a non-authenticated user tries to generate a result.
 * On sign up/log in, the caller is expected to persist the pending inputs
 * in sessionStorage under `armeria_pending_generate` so the tool page can
 * auto-resubmit after the user returns.
 */
export const LoginRequiredModal = ({ open, onClose, toolId, inputs }) => {
  if (!open) return null;

  const savePendingAndNavigate = (path) => {
    try {
      // Use localStorage (more resilient than sessionStorage — survives tab switches,
      // browser session resets, and various Kubernetes/CDN edge cases in prod).
      // The AuthPage + PublicRoute will read this after successful auth.
      localStorage.setItem(
        "armeria_pending_generate",
        JSON.stringify({ tool_id: toolId, inputs, ts: Date.now() })
      );
      localStorage.setItem("armeria_return_to", window.location.pathname);
    } catch (e) { /* silent */ }
  };

  // Build /registro URL that ALSO carries next= as a fallback in case
  // localStorage gets cleared before we can read it back.
  const signupHref = `/registro?ref=armeria-${toolId}&next=${encodeURIComponent(window.location.pathname)}`;
  const loginHref = `/login?next=${encodeURIComponent(window.location.pathname)}`;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999, padding: "20px", backdropFilter: "blur(4px)"
      }}
      data-testid="armeria-login-modal"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="armeria-root"
        style={{
          background: "#14110c", border: "1px solid rgba(200, 146, 42, 0.55)",
          borderRadius: "16px", padding: "36px 32px", maxWidth: "480px", width: "100%",
          position: "relative", boxShadow: "0 20px 60px rgba(0,0,0,0.6)"
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute", top: "16px", right: "16px",
            background: "transparent", border: "none", color: "#a89b83", cursor: "pointer"
          }}
          data-testid="armeria-modal-close"
        >
          <X size={20} />
        </button>

        <div style={{ marginBottom: "8px" }}>
          <span className="arm-badge">La Armería · El Maestro Armero</span>
        </div>

        <h2 style={{ fontSize: "26px", lineHeight: "1.2", margin: "12px 0 10px", color: "#c8922a", fontFamily: "'Playfair Display', serif" }}>
          Crea tu cuenta gratuita para ver tu resultado
        </h2>

        <p style={{ color: "#a89b83", fontSize: "15px", lineHeight: "1.55", marginBottom: "24px" }}>
          Sin tarjeta. <strong style={{ color: "#f5efe4" }}>20 créditos gratis</strong> al registrarte.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Link
            to={signupHref}
            onClick={() => savePendingAndNavigate("/registro")}
            className="arm-btn-primary"
            style={{ textAlign: "center", textDecoration: "none", display: "block" }}
            data-testid="armeria-modal-signup"
          >
            Crear cuenta gratis
          </Link>
          <Link
            to={loginHref}
            onClick={() => savePendingAndNavigate("/login")}
            className="arm-btn-outline"
            style={{ textAlign: "center", textDecoration: "none", display: "block" }}
            data-testid="armeria-modal-login"
          >
            Ya tengo cuenta — Iniciar sesión
          </Link>
        </div>

        <p style={{ color: "#a89b83", fontSize: "11px", marginTop: "20px", textAlign: "center", fontFamily: "'IBM Plex Mono', monospace" }}>
          Herramientas 100% gratuitas · sin límite de uso
        </p>
      </div>
    </div>
  );
};
